module.exports = __webpack_public_path__ + "static/media/infrastructure.ea0864ad.png";